"use strict";
import { jsx } from "react/jsx-runtime";
import EmailViewer from "../accounts_payable/indexer/email_viewer";
export default {
  emailMessages: function(messages, documentFromEmail, callback) {
    return /* @__PURE__ */ jsx("div", { className: "email-viewer__thread-container", children: this.emailMessagesDetail(messages, documentFromEmail, callback) });
  },
  emailMessagesDetail: function(messages, documentFromEmail, callback) {
    return messages.map((email) => {
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: "email-viewer__thread-item",
          children: /* @__PURE__ */ jsx(
            EmailViewer,
            {
              message: email,
              documentFromEmail,
              documentFromEmailCallback: callback
            }
          )
        },
        "email-detail-" + email.id
      );
    });
  }
};
